import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  lead,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-51" data-mp="3k06w9t0d6pxq">
      {eyebrow && <p className={`text-sm font-bold uppercase tracking-[0.14em] ${dark ? "text-sky-300" : "text-brand"}`} data-id="element-52" data-mp="3k0f6te90lj5r">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-serif text-[2rem] font-extrabold leading-[1.12] sm:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-53" data-mp="gjq11uh9adh5">
        {title}
      </h2>
      {lead && <p className={`mt-4 text-lg leading-relaxed ${dark ? "text-white/80" : "text-muted"}`} data-id="element-54" data-mp="6tn6vqyeeth8">{lead}</p>}
    </div>;
}